import { mapCurrency } from '@webapp/core/data-access/mappers/mapCurrency'
import { ExpensePaymentTypes } from '@webapp/modules/expense/entities/enums/ExpensePaymentTypeEnum'
import { ExpenseTypes } from '@webapp/modules/expense/entities/enums/ExpenseTypeEnum'
import { type ExpenseItemConstructor } from '@webapp/modules/expense/entities/ExpenseItem'
import { type ApprovableExpenseItemApiModel } from '../api-models/ApprovableExpenseSummaryApiModel'

export const mapApprovableExpenseItemApiModel = (
  item: ApprovableExpenseItemApiModel
): ExpenseItemConstructor => ({
  id: item.id,
  merchant: item.merchant,
  amount: parseFloat(item.amount),
  reimbursable: item.reimburse,
  taxAmount: parseFloat(item.tax_amount),
  taxPercentage: item.tax_percentage,
  taxName: item.tax_name,
  taxId: item.tax,
  notes: item.notes || '',
  attachment: item.attachment || null,
  transactionDate: item.transDate,
  currency: mapCurrency(item.localCurrency),
  account: {
    id: item.account.id,
    accountCode: {
      id: item.account.account_code.id,
      description: item.account.account_code.description,
      code: item.account.account_code.code,
      type: item.account.account_code.account_type,
    },
    active: true,
    secondaryCategory: {
      id: item.account.department.id,
      name: item.account.department.name,
      primaryCategory: {
        id: item.account.department.branch.id,
        name: item.account.department.branch.name,
      },
    },
  },
  paymentCard: item.creditcard
    ? {
        id: item.creditcard.id,
        name: item.creditcard.name,
        last4Digits: item.creditcard.number,
        vendor: item.creditcard.type,
      }
    : null,
  expenseType: ExpenseTypes.OTHER,
  paymentType: ExpensePaymentTypes.CASH,
  expenseTypeData: { type: 'OTHER' as const, data: null },
})
